/**
 * Checks if a URL redirects to a product page
 * @param url - The URL to check
 * @returns true if the URL redirects to a product page, false otherwise
 */
export const isProductPageUrl = (url: string): boolean => {
  const cleanUrl = url.split('?')[0].split('#')[0]
  return cleanUrl.includes('/product/') || cleanUrl.endsWith('/product')
}
